import { c as _c } from "react/compiler-runtime";
import { Box, Grid, Stack } from "@mui-wrapper";
import { Skeleton } from "@flat-ui";
import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
import { formatNumber } from "@utils/data-display";
import { useMemo } from "react";
import { useMediaQueryList } from "@hooks/use-media-query";

/** Common style for the info bar items */
const infoBarItemStyle = {
  bgcolor: "surfaces.secondary",
  padding: 2.5,
  height: {
    xs: "80px",
    sm: "90px",
    md: "100px"
  }
};

/** Font sizes for different screen sizes using rem units */
const fontSizes = {
  sm: "1.125rem",
  md: "1.5rem",
  lg: "2rem"
};
/**
 * Component that shows an information bar about the current dialog.
 */
export function DialogInfoBar(t0) {
  const $ = _c(6);
  const {
    isLoading: t1,
    items
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const {
    isScreenSmOrSmaller,
    isScreenMdOrSmaller,
    isScreenMdOrLarger
  } = useMediaQueryList();
  let t2;
  bb0: {
    if (isScreenSmOrSmaller) {
      t2 = fontSizes.sm;
      break bb0;
    }
    if (isScreenMdOrSmaller) {
      t2 = fontSizes.md;
      break bb0;
    }
    if (isScreenMdOrLarger) {
      t2 = fontSizes.lg;
      break bb0;
    }
    t2 = undefined;
  }
  const valueFontSize = t2;
  if (isLoading) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Box component="div" sx={{
        height: infoBarItemStyle.height
      }}><Skeleton variant="rectangular" height="100%" /></Box>;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    return t3;
  }
  let t3;
  if ($[1] !== items || $[2] !== valueFontSize) {
    t3 = items?.map((item, index) => <Grid size={{
      xs: 12,
      sm: 6
    }} key={index}><Stack direction="row" sx={{
        ...infoBarItemStyle,
        justifyContent: "space-between",
        alignItems: "center",
        gap: 1
      }}><Box sx={{
          flexGrow: 1,
          minWidth: 0
        }}><FaroTextField label={item.label} initialValue={formatNumber(item.initialValue)} faroVariant="main" fontSize={valueFontSize} /></Box>{item.action && <Box sx={{
          flexShrink: 0
        }}>{item.action}</Box>}</Stack></Grid>);
    $[1] = items;
    $[2] = valueFontSize;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Grid container={true} spacing={1}>{t3}</Grid>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}